import { Loader2 } from 'lucide-react';

const LoadingSpinner = () => <Loader2 className="animate-spin" />;

export default LoadingSpinner;
